export const ADD_VENUE_LOG = 'ADD_VENUE_LOG';
export const ADD_VENUE_LOG_SUCCESS = 'ADD_VENUE_LOG_SUCCESS';
export const ADD_VENUE_LOG_ERROR = 'ADD_VENUE_LOG_ERROR';

export const AddVenueLog = (data) => ({
  type: ADD_VENUE_LOG,
  payload: data,
});
